/** Aggregazione delle serie mensili per mese/trimestre/anno + confronto anno su anno. */
const MESI_BREVI = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

export const GRANULARITA = [
  { key: 'mese', label: 'Mese' },
  { key: 'trimestre', label: 'Trimestre' },
  { key: 'anno', label: 'Anno' },
];

export const chiaveGruppo = (mese, gran) => {
  const anno = mese.slice(0, 4);
  if (gran === 'anno') return anno;
  if (gran === 'trimestre') return `${anno}-T${Math.ceil(Number(mese.slice(5, 7)) / 3)}`;
  return mese;
};

export const etichettaGruppo = (chiave, gran) => {
  if (gran === 'anno') return chiave;
  if (gran === 'trimestre') return `${chiave.slice(5)} ${chiave.slice(2, 4)}`;
  return `${MESI_BREVI[Number(chiave.slice(5, 7)) - 1]} ${chiave.slice(2, 4)}`;
};

export const chiaveAnnoPrima = (chiave, gran) => {
  const anno = Number(chiave.slice(0, 4)) - 1;
  return gran === 'anno' ? String(anno) : `${anno}${chiave.slice(4)}`;
};

/** Somma i campi indicati sui gruppi e ricalcola gli indici derivati con `deriva`. */
export const aggrega = (righe, gran, campiSomma, deriva) => {
  const gruppi = new Map();
  righe.forEach((r) => {
    const chiave = chiaveGruppo(r.mese, gran);
    if (!gruppi.has(chiave)) {
      const vuoto = { chiave, label: etichettaGruppo(chiave, gran), righe: [], n_mesi: 0 };
      campiSomma.forEach((c) => { vuoto[c] = 0; });
      gruppi.set(chiave, vuoto);
    }
    const g = gruppi.get(chiave);
    g.righe.push(r);
    g.n_mesi += 1;
    campiSomma.forEach((c) => { g[c] = Number((g[c] + (r[c] || 0)).toFixed(2)); });
  });
  const out = [...gruppi.values()].sort((a, b) => (a.chiave < b.chiave ? -1 : 1));
  return deriva ? out.map((g) => ({ ...g, ...deriva(g) })) : out;
};

/** Aggiunge a ogni gruppo il valore dello stesso periodo dell'anno precedente. */
export const conAnnoPrima = (gruppi, gran, chiaveValore) => {
  const indice = new Map(gruppi.map((g) => [g.chiave, g]));
  return gruppi.map((g) => {
    const prec = indice.get(chiaveAnnoPrima(g.chiave, gran));
    const valore = g[chiaveValore];
    const valore_prec = prec ? prec[chiaveValore] : null;
    return {
      ...g,
      valore,
      valore_prec,
      label_prec: prec?.label || null,
      delta_pct: valore_prec ? Number((((valore - valore_prec) / Math.abs(valore_prec)) * 100).toFixed(1)) : null,
    };
  });
};

export const div = (a, b, dec = 2) => (b ? Number((a / b).toFixed(dec)) : null);
export const pctSu = (a, b) => (b ? Number(((a / b) * 100).toFixed(2)) : null);
